import { type RequestComment } from './revisionRequest'
import { TimeAgo } from '@/components/TimeAgo'

const SECTION_NAME: Record<RequestComment['section'], string> = {
  overall: 'Overall Plan', channel: 'Channel Breakdown', quarterly: 'Channel Quarterly Breakdown',
}

// Comments whose row is no longer in the plan (removed by a later revision,
// or not in the draft). Shown under the tables so nothing written is lost.
export default function OrphanCommentsBlock({ comments, readOnly = false, onDelete }: {
  comments: RequestComment[]; readOnly?: boolean; onDelete?: (id: string) => void
}) {
  if (comments.length === 0) return null
  return (
    <div className="mt-5 rounded-lg border px-4 py-3" style={{ background: 'var(--background)', borderColor: 'var(--border)' }}>
      <h3 className="text-sm font-semibold text-foreground">Rows no longer in the plan</h3>
      <ul className="mt-2 flex flex-col gap-2">
        {comments.map((c) => (
          <li key={c.id} className="text-sm">
            <div className="text-xs text-muted-foreground">
              <span className="font-semibold text-foreground">{c.anchor_label}</span> · {SECTION_NAME[c.section]} · {c.author} · <TimeAgo at={c.at} />
            </div>
            <p className="whitespace-pre-line text-[13px] text-foreground">{c.body}</p>
            {!readOnly && c.mine && onDelete && (
              <button type="button" onClick={() => onDelete(c.id)} className="text-xs text-muted-foreground hover:underline">Delete</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
